// @flow
import connectWebActions from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents } from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks from 'fg-frontend/src/components/safeBlankLinks';

import configureWebComponents from './configureWebComponents';
import configureWebActions from './configureWebActions';
import cookiesPolicy from './components/CookiesPolicy4/index';
import phoneLink from 'fg-frontend/components/PhoneLink';
import 'fg-frontend/ramjet/liveValidation';

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, ['keyup']);
autoTitleLinksWithBlankTarget();
cookiesPolicy();
phoneLink();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();

// Nastaveni sirky scrollbaru do property
document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");
// Nastaveni vysky viewportu do property
document.documentElement.style.setProperty('--app-height', window.innerHeight + "px");
// Nastaveni vysky headeru baru
document.documentElement.style.setProperty('--header-bar-height', '40px');



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWeb.js